<script lang="ts">
    import TemplateSettingsGeneral from "./TemplateSettingsGeneral.svelte";
    import {_} from 'svelte-i18n';
    import {customerSettings} from '../../../stores/api';
    import SettingsRowNumber from "./SettingsRowNumber.svelte";
    import SettingsRow from "./SettingsRow.svelte";
    import SettingsRowLabel from "./SettingsRowLabel.svelte";
    import SettingsRowValue from "./SettingsRowValue.svelte";
    import Checkbox from "../../shared/Checkbox/Checkbox.svelte";
    import {z} from "zod";

    export let update: () => void;

    function validator(data: unknown) {
        return z.coerce.number().int().min(0).max(60).safeParse(data);
    }

</script>


<TemplateSettingsGeneral>
    <div slot="label">{$_('settings-route-params')}</div>
    <div slot="content">
        <SettingsRow>
            <SettingsRowLabel>
                {$_('settings-route-params-ignore-last-point')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <Checkbox
                    bind:checked={$customerSettings.ignore_last_point_on_optimization}
                    label=""
                    onChange={s => {
                        update();
                        return true;
                    }}
                />
            </SettingsRowValue>
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>
